export default "__VITE_ASSET__CakzsqDg__";